<template>
  <div data-modal="information" class="panel mb-0 panel-information">
    <div class="panel-hdr">
      <h2 data-status="up" style="line-height: 1.5rem" v-if="event.status == 'up'">Информация об ответе</h2>
      <h2 data-status="down" style="line-height: 1.5rem" v-if="event.status == 'down'">Информация об ошибке</h2>
      <div class="panel-toolbar pr-0">
        <button type="button" @click="$emit('close')" class="close">
          <span>
            <i class="fal fa-times"></i>
          </span>
        </button>
      </div>
    </div>
    <div class="panel-container show">
      <div class="panel-content">
        <pre class="panel-tag" v-if="event.content">{{ event.content }}</pre>
        <pre class="panel-tag" v-if="!event.content">нет информации</pre>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['event'],
  }
</script>

<style>
  pre {
    max-height: 500px;
  }
</style>